import {Record as record, Map} from 'immutable';

const NavigationRecord = record(
    {
        navActiveTabIndex: 0,
        waypointsInView: new Map()
    },
    'NavigationRecord'
);

export default NavigationRecord;
export {NavigationRecord};
